import { Box, Flex } from '@cmpsr/components';
import Marquee from 'react-fast-marquee';

const proofImages = Array.from({ length: 6 }, (_, i) => ({
  src: `/images/social-proof/unified/socialproof-${i + 1}.webp`,
  alt: `Social proof ${i + 1}`,
}));

export const ImageCarousel = () => {
  return (
    <Flex width="100%" position="relative" overflow="hidden">
      <Marquee speed={40} direction="left" gradient={false} autoFill={true}>
        {proofImages.map((image, index) => (
          <Box key={index} padding="0 12px" width={{ base: '250px', lg: '350px' }}>
            <img src={image.src} alt={image.alt} style={{ width: '100%', height: 'auto', borderRadius: '8px' }} />
          </Box>
        ))}
      </Marquee>
    </Flex>
  );
};

export default ImageCarousel;
